
// noinspection JSAnnotator

export default {
	global: {
		faq1: {
			name: 'faq-1',
			url: 'https://support.nexon.net/hc/articles/204157969-What-is-NX-'
		},
		faq2: {
			name: 'faq-2',
			url: 'https://support.nexon.net/hc/articles/210007126-Mobile-payments-supported-carriers'
		},
		faq3: {
			name: 'faq-3',
			url: 'https://support.nexon.net/hc/articles/213735643-Credit-Card-Policy'
		},
	},
	th: {
		faq1: {
			name: 'faq-1',
			url: 'https://th.nexon.com/forum/th/forum/283/board/664/thread/33022',
		},
		faq2: {
			name: 'faq-2',
			url: 'https://th.nexon.com/forum/th/forum/283/board/664/thread/33021',
		},
		faq3: {
			name: 'faq-3',
			url: 'https://th.nexon.com/forum/th/forum/283/board/664/thread/33020',
		},
	},
	tw: {
		faq1: {
			name: 'faq-1',
			url: 'https://tw.nexon.com/forum/zh/forum/264/board/630/thread/37276'
		},
		faq2: {
			name: 'faq-2',
			url: 'https://tw.nexon.com/forum/zh/forum/264/board/630/thread/32970'
		},
		faq3: {
			name: 'faq-3',
			url: 'https://tw.nexon.com/forum/zh/forum/264/board/630/thread/32971'
		},
	},
	sea: {
		faq2: {
			name: 'faq-2',
			url: 'https://support.nexon.net/hc/articles/210007126-Mobile-payments-supported-carriers'
		},
		faq3: {
			name: 'faq-3',
			url: 'https://support.nexon.net/hc/articles/213735643-Credit-Card-Policy'
		},
	},
};




// WEBPACK FOOTER //
// ./src/config/add-balance-faq-list.js